import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/styles';
import { flags } from 'app-constants';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import dateFormat from 'utils/date';

const useStyle = makeStyles({
  gridCell: {
    padding: [[20]],
    display: 'inline-block',
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
    textAlign: 'left',
    width: '100%'
  },
  noDataMessage: {
    margin: [[20]],
    textAlign: 'center'
  }
});

function GridHeaderItem(props) {
  const { children, classes, ...rest } = props;
  return (
    <Grid item {...rest}>
      <Typography
        variant="caption"
        gutterBottom
        className={classes.gridCell}
        color="textSecondary"
      >
        {children}
      </Typography>
    </Grid>
  );
}

export default function ApplicationListGrid({
  applicationsList,
  onAppAdd,
  onEnvAdd,
  onAppSelect
}) {
  const isAddEnvAllow = flags.IsAddEnvironmentShow();
  const smSize = isAddEnvAllow ? 2 : 3;
  const classes = useStyle();

  const onEnvAddHandler = (appId) => () => {
    onEnvAdd(appId);
  };

  const onAppSelectHandler = (appId) => () => {
    onAppSelect(appId);
  };

  if (!applicationsList || !applicationsList.length) {
    return (
      <Typography
        variant="h6"
        color="textSecondary"
        className={classes.noDataMessage}
      >
        No applications to show. Please create one.
      </Typography>
    );
  }

  return (
    <>
      <AppBar position="static" color="default" elevation={0}>
        <Toolbar>
          <Grid
            container
            justify="flex-end"
            alignItems="center"
            data-testid="grid-list-actions"
            spacing={16}
          >
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={onAppAdd}
                data-testid="add-app-button"
              >
                + Add Application
              </Button>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>

      <Grid container data-testid="grid-list-header">
        <GridHeaderItem xs={12} sm={3} classes={classes}>
          Name
        </GridHeaderItem>
        <GridHeaderItem xs={12} sm={3} classes={classes}>
          App Id
        </GridHeaderItem>
        <GridHeaderItem xs={12} sm={smSize} classes={classes}>
          Create By
        </GridHeaderItem>
        <GridHeaderItem xs={12} sm={smSize} classes={classes}>
          Create Since
        </GridHeaderItem>
        {isAddEnvAllow && <GridHeaderItem xs={12} sm={2} classes={classes} />}
        <Grid item xs={12}>
          <Divider />
        </Grid>
      </Grid>
      {applicationsList.map((application) => {
        return (
          <div key={application.uId} data-testid="grid-data-row">
            <Grid container alignItems="center">
              <Grid item xs={12} sm={3}>
                <Link
                  component="button"
                  onClick={onAppSelectHandler(application.appId)}
                  className={classes.gridCell}
                  variant="body2"
                >
                  {application.name}
                </Link>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Typography variant="body2" className={classes.gridCell}>
                  <i>{application.appId}</i>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={smSize}>
                <Typography variant="body2" className={classes.gridCell}>
                  {application.createByUser
                    ? application.createByUser.name
                    : 'admin'}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={smSize}>
                <Typography variant="body2" className={classes.gridCell}>
                  {dateFormat.timeAgo(application.createAt)}
                </Typography>
              </Grid>
              {isAddEnvAllow && (
                <Grid item xs={12} sm={2}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={onEnvAddHandler(application.appId)}
                    data-testid="add-env-button"
                    size="small"
                  >
                    +Environment
                  </Button>
                </Grid>
              )}
            </Grid>
            <Divider light />
          </div>
        );
      })}
    </>
  );
}

ApplicationListGrid.defaultProps = {
  applicationsList: []
};
